import API from '@/utils/API';
import {
  IProposal,
  IVariablesProposal,
  IUpdateProposal,
  IDeleteProposal,
  IBid,
  IUpdateBid
} from '@/types/API';

export const createPreBid = (variables: IVariablesProposal) => {
  const query = /* GraphQL */ `
    mutation createProposal(
      $assetId: String!
      $bidDescription: String
      $partsOfBidValue: [String]!
      $partsOfBidValueCount: Int!
      $status: ProposalStatus
      $question_responses: [QuestionResponseInput]
    ) {
      createProposal(
        assetId: $assetId
        partsOfBidValue: $partsOfBidValue
        partsOfBidValueCount: $partsOfBidValueCount
        bidDescription: $bidDescription
        status: $status
        question_responses: $question_responses
      ) {
        id
        ownerId
        owner {
          PK
          SK
          id
          email
          type
          avatar
          firstName
          lastName
          phoneNumber
        }
        assetId
        bidValue
        partsOfBidValue
        status
        createdAt
        updatedAt
        bidDescription
        question_responses {
          question_index
          answer
          word_count
        }
      }
    }
  `;

  return API.graphql<IProposal>('asset', {
    query,
    variables
  });
};

export const updateProposal = (variables: IUpdateProposal) => {
  const query = /* GraphQL */ `
    mutation updateProposal(
      $assetId: String!
      $partsOfBidValue: [String]
      $status: ProposalStatus
      $bidDescription: String
      $question_responses: [QuestionResponseInput]
    ) {
      updateProposal(
        assetId: $assetId
        partsOfBidValue: $partsOfBidValue
        status: $status
        bidDescription: $bidDescription
        question_responses: $question_responses
      ) {
        id
        ownerId
        owner {
          PK
          SK
          id
          email
          type
          avatar
          firstName
          lastName
          phoneNumber
        }
        assetId
        bidValue
        partsOfBidValue
        status
        createdAt
        updatedAt
        bidDescription
        question_responses {
          question_index
          answer
          word_count
        }
      }
    }
  `;

  return API.graphql<IProposal>('asset', {
    query,
    variables
  });
};

export const deleteProposal = (variables: IDeleteProposal) => {
  const query = /* GraphQL */ `
    mutation deleteProposal($assetId: String!) {
      deleteProposal(assetId: $assetId) {
        id
        ownerId
        owner {
          PK
          SK
          id
          email
          type
          avatar
          firstName
          lastName
          phoneNumber
        }
        assetId
        bidValue
        partsOfBidValue
        status
        createdAt
        updatedAt
      }
    }
  `;

  return API.graphql<IProposal>('asset', {
    query,
    variables
  });
};

export const updateBid = (variables: IUpdateBid) => {
  const query = /* GraphQL */ `
    mutation updateBid(
      $auctionId: String!
      $save: Boolean!
      $createOrUpdate: Boolean
      $attributes: BidAttributeUpdate
    ) {
      updateBid(
        auctionId: $auctionId
        save: $save
        createOrUpdate: $createOrUpdate
        attributes: $attributes
      ) {
        PK
        SK
        id
        auctionId
        ownerId
        owner {
          PK
          SK
          id
          email
          type
          avatar
          firstName
          lastName
          phoneNumber
        }
        assetId
        bidValue
        partsOfBidValue
        createdAt
        docType
      }
    }
  `;

  return API.graphql<IBid>('auctions', {
    query,
    variables
  });
};

export const getProposalInfo = (variables: {
  assetId: string;
  ownerId?: string;
}) => {
  const query = /* GraphQL */ `
    query getProposalInfo($assetId: String!, $ownerId: String) {
      getProposalInfo(assetId: $assetId, ownerId: $ownerId) {
        id
        ownerId
        assetId
        bidValue
        partsOfBidValue
        status
        createdAt
        updatedAt
        bidDescription
        question_responses {
          question_index
          answer
          word_count
        }
      }
    }
  `;

  return API.graphql<IProposal>('asset', {
    query,
    variables
  });
};
